/**
 * Steps enum
 * !!!Important!!! -> Currently the enum attribute values have to match AdmissionData Interface, as it's the way that the
 * method Register.tsx@getCompleteAdmissionData() is using object destructuring to use the data.
 * @see AdmissionData
 * @see Register.tsx
 */
export enum StepEnum {
  PERSONAL_DATA = 'personal',
  ADDRESS = 'address',
  PERSONAL_DOCUMENTS = 'personalDocuments',
  PROFESSIONAL_DOCUMENTS = 'professionalDocuments',
  BANK_DETAILS = 'banking',
  DEPENDENTS = 'dependents',
  DOCUMENTS_UPLOADS = 'documentsUploads',
  FINALIZATION = 'finalization',
  FINALIZATION_CONFIRMATION = 'finalization_confirmation',
}